import React from 'react'

const NavCard = ({name,price,image,index}) => {
    console.log("navcard",name,price)
    return (
    <>
       <div className="NavCard">
     
                <div className="Navcardwhole">
                    <img src={image} alt={`${index} phone`} />
                    <p>{name}</p>
                    <span>{price}</span>  
                </div>

      </div>     
    </> 
    )
}

export default NavCard
